module.exports = __webpack_public_path__ + "static/media/21_after.98b8b948.jpg";